import { Component, signal, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogModule, DialogRef } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { CapitalizePipe } from "../../../pipes/capitalize.pipe";
import { FormErrorService } from "../../../services/serverError.service";
import { DialogResult } from "../../../types/DialogResult";

@Component({
  selector: 'rc-mercure-overtaken-popup-message',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    CapitalizePipe,
    InputsModule,
    LabelModule,
    ComboBoxModule,
    ButtonsModule,
    DialogModule,
  ],
  providers: [FormErrorService, TranslatePipe, NotificationService],
  templateUrl: './mercure-overtaken-popup-message.component.html',
  styleUrl: './mercure-overtaken-popup-message.component.scss',
})
export class MercureOvertakenPopupMessageComponent extends DialogContentBase {
  user = signal<string>('');
  name = signal<string>('');

  constructor() {
    const dialog = inject(DialogRef);

    super(dialog);
  }

  accept() {
    const val: DialogResult = { text: 'item-overtaken', isSuccessFull: true };
    this.dialog.close(val);
  }
}
